import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { TotpSetupResponse } from 'src/app/models/mfa/mfa.model';
import { IsUserRegistered } from 'src/app/models/register/is-user-registered.model';
import { RegisterPayload } from 'src/app/models/register/register-payload.model';
import { ApiService } from '../api.service';

@Injectable()
export class RegisterService {
  constructor(private apiSvc: ApiService) {}

  isUserRegistered(token: string) {
    const url = `invites?token=${token}`;
    return this.apiSvc.get<IsUserRegistered>(url, {}, false);
  }

  /** QR code and secret for the authenticator that is confirmed by `totpCode` on registration. */
  getTotpSetup(token: string, login: string, email: string): Observable<TotpSetupResponse> {
    const url = 'users/register/totp';
    return this.apiSvc.post<TotpSetupResponse>(url, { token, login, email }, {}, false);
  }

  register(payload: RegisterPayload) {
    const url = 'users/register';
    return this.apiSvc.post(url, payload, {}, false);
  }
}
